import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/manage/currency/currency.service';

@Pipe({
  name: 'priceFilter',
  pure: false
})
export class PriceFilterPipe implements PipeTransform {

  currencySymbol: string  ='';
  currencyDecimal: number =0;

  constructor(
    private currencyMng: CurrencyService
  ) {
    this.currencyMng.getCurrCurrency().subscribe(data => {
      this.currencySymbol = data.symbol;
      this.currencyDecimal = data.decimal;
    });
  }

  transform(value: any, symbol?: string, decimal?: any): any {
  
   
    const currSymbol = (symbol) ? symbol : this.currencySymbol;
     const currDecimal = (decimal) ? decimal : this.currencyDecimal;

    if (currDecimal === 0) {

      return value + currSymbol;

    } else {

      let roundedVal = Math.round(parseFloat(value) * 100) / 100;
      let valStr: string = roundedVal.toString();
      let newVal: string;

      if (!valStr.includes(".")) {

        newVal = valStr.concat(".00" + currSymbol);

      } else {

        let valSpl = valStr.split(".");
        newVal = (valSpl[1].length > 1) ? valStr.concat(currSymbol) : valStr.concat("0" + currSymbol);

      };

      return newVal;

    }


  }

}
